// Section 1: Background Questions
export const backgroundQuestions = [
    {
        id: 'bg_role',
        section: 1,
        order: 1,
        type: 'single_select',
        required: true,
        text: {
            sv: 'Vilken roll har du i företaget?',
            en: 'What is your role in the company?',
        },
        options: [
            { value: 'ceo', label: { sv: 'VD / Ägare', en: 'CEO / Owner' } },
            { value: 'cto', label: { sv: 'CTO / IT-chef', en: 'CTO / IT Manager' } },
            { value: 'cfo', label: { sv: 'CFO / Ekonomichef', en: 'CFO / Finance Manager' } },
            { value: 'operations', label: { sv: 'COO / Verksamhetschef', en: 'COO / Operations Manager' } },
            { value: 'marketing', label: { sv: 'Marknadschef', en: 'Marketing Manager' } },
            { value: 'sales', label: { sv: 'Försäljningschef', en: 'Sales Manager' } },
            { value: 'hr', label: { sv: 'HR-chef', en: 'HR Manager' } },
            { value: 'other_manager', label: { sv: 'Annan chef', en: 'Other Manager' } },
            { value: 'employee', label: { sv: 'Medarbetare', en: 'Employee' } },
        ],
        scoringDimension: 'role',
        scoringWeight: 15,
    },
    {
        id: 'bg_company_size',
        section: 1,
        order: 2,
        type: 'single_select',
        required: true,
        text: {
            sv: 'Hur många anställda har ert företag?',
            en: 'How many employees does your company have?',
        },
        options: [
            { value: '1-9', label: { sv: '1-9 anställda', en: '1-9 employees' } },
            { value: '10-49', label: { sv: '10-49 anställda', en: '10-49 employees' } },
            { value: '50-99', label: { sv: '50-99 anställda', en: '50-99 employees' } },
            { value: '100-249', label: { sv: '100-249 anställda', en: '100-249 employees' } },
            { value: '250+', label: { sv: '250+ anställda', en: '250+ employees' } },
        ],
        scoringDimension: 'companySize',
        scoringWeight: 15,
    },
    {
        id: 'bg_industry',
        section: 1,
        order: 3,
        type: 'single_select',
        required: true,
        text: {
            sv: 'Vilken bransch verkar ni inom?',
            en: 'What industry do you operate in?',
        },
        options: [
            { value: 'manufacturing', label: { sv: 'Tillverkning', en: 'Manufacturing' } },
            { value: 'retail', label: { sv: 'Detaljhandel', en: 'Retail' } },
            { value: 'healthcare', label: { sv: 'Hälso- och sjukvård', en: 'Healthcare' } },
            { value: 'finance', label: { sv: 'Finans och försäkring', en: 'Finance & Insurance' } },
            { value: 'tech', label: { sv: 'IT och teknik', en: 'IT & Technology' } },
            { value: 'construction', label: { sv: 'Bygg och fastighet', en: 'Construction & Real Estate' } },
            { value: 'logistics', label: { sv: 'Transport och logistik', en: 'Transport & Logistics' } },
            { value: 'hospitality', label: { sv: 'Hotell och restaurang', en: 'Hospitality' } },
            { value: 'professional', label: { sv: 'Professionella tjänster', en: 'Professional Services' } },
            { value: 'education', label: { sv: 'Utbildning', en: 'Education' } },
            { value: 'other', label: { sv: 'Annan bransch', en: 'Other industry' } },
        ],
    },
    {
        id: 'bg_revenue',
        section: 1,
        order: 4,
        type: 'single_select',
        required: false,
        text: {
            sv: 'Vad är företagets ungefärliga årsomsättning?',
            en: "What is your company's approximate annual revenue?",
        },
        options: [
            { value: 'under_5m', label: { sv: 'Under 5 MSEK', en: 'Under 5 MSEK' } },
            { value: '5-20m', label: { sv: '5-20 MSEK', en: '5-20 MSEK' } },
            { value: '20-50m', label: { sv: '20-50 MSEK', en: '20-50 MSEK' } },
            { value: '50-100m', label: { sv: '50-100 MSEK', en: '50-100 MSEK' } },
            { value: '100-500m', label: { sv: '100-500 MSEK', en: '100-500 MSEK' } },
            { value: 'over_500m', label: { sv: 'Över 500 MSEK', en: 'Over 500 MSEK' } },
            { value: 'prefer_not', label: { sv: 'Vill ej uppge', en: 'Prefer not to say' } },
        ],
    },
];
// Section 2: AI Maturity Questions
export const aiMaturityQuestions = [
    // Strategy Dimension
    {
        id: 'ai_strategy_awareness',
        section: 2,
        order: 1,
        type: 'single_select',
        required: true,
        text: {
            sv: 'Hur väl känner du till AI och dess möjligheter för ert företag?',
            en: 'How familiar are you with AI and its possibilities for your company?',
        },
        options: [
            { value: '1', label: { sv: 'Inte alls bekant', en: 'Not familiar at all' } },
            { value: '2', label: { sv: 'Lite bekant', en: 'Slightly familiar' } },
            { value: '3', label: { sv: 'Måttligt bekant', en: 'Moderately familiar' } },
            { value: '4', label: { sv: 'Mycket bekant', en: 'Very familiar' } },
            { value: '5', label: { sv: 'Expert', en: 'Expert' } },
        ],
        scoringDimension: 'strategy',
        scoringWeight: 5,
    },
    {
        id: 'ai_strategy_plan',
        section: 2,
        order: 2,
        type: 'single_select',
        required: true,
        text: {
            sv: 'Har ert företag en strategi eller plan för att använda AI?',
            en: 'Does your company have a strategy or plan for using AI?',
        },
        options: [
            { value: 'none', label: { sv: 'Nej, ingen plan', en: 'No, no plan' } },
            { value: 'considering', label: { sv: 'Vi överväger det', en: 'We are considering it' } },
            { value: 'informal', label: { sv: 'Informella diskussioner', en: 'Informal discussions' } },
            { value: 'developing', label: { sv: 'Under utveckling', en: 'In development' } },
            { value: 'implemented', label: { sv: 'Ja, implementerad', en: 'Yes, implemented' } },
        ],
        scoringDimension: 'strategy',
        scoringWeight: 10,
    },
    // Current Usage Dimension
    {
        id: 'ai_current_usage',
        section: 2,
        order: 3,
        type: 'multi_select',
        required: true,
        text: {
            sv: 'Vilka AI-verktyg eller tekniker använder ni idag? (Välj alla som gäller)',
            en: 'What AI tools or techniques do you use today? (Select all that apply)',
        },
        options: [
            { value: 'none', label: { sv: 'Inga', en: 'None' } },
            { value: 'chatgpt', label: { sv: 'ChatGPT / Generativ AI', en: 'ChatGPT / Generative AI' } },
            { value: 'analytics', label: { sv: 'AI-driven analys', en: 'AI-powered analytics' } },
            { value: 'automation', label: { sv: 'Processautomation', en: 'Process automation' } },
            { value: 'customer_service', label: { sv: 'AI kundtjänst / chatbot', en: 'AI customer service / chatbot' } },
            { value: 'marketing', label: { sv: 'AI för marknadsföring', en: 'AI for marketing' } },
            { value: 'sales', label: { sv: 'AI för försäljning', en: 'AI for sales' } },
            { value: 'custom', label: { sv: 'Egenutvecklade AI-lösningar', en: 'Custom-built AI solutions' } },
        ],
        validation: {
            minSelections: 1,
        },
        scoringDimension: 'technology',
        scoringWeight: 10,
    },
    // Data Dimension
    {
        id: 'ai_data_quality',
        section: 2,
        order: 4,
        type: 'scale',
        required: true,
        text: {
            sv: 'Hur skulle du bedöma kvaliteten på era företagsdata?',
            en: 'How would you rate the quality of your company data?',
        },
        description: {
            sv: '1 = Dålig kvalitet, ostrukturerat, 5 = Utmärkt kvalitet, välstrukturerat',
            en: '1 = Poor quality, unstructured, 5 = Excellent quality, well-structured',
        },
        validation: {
            min: 1,
            max: 5,
        },
        scoringDimension: 'data',
        scoringWeight: 10,
    },
    {
        id: 'ai_data_accessibility',
        section: 2,
        order: 5,
        type: 'single_select',
        required: true,
        text: {
            sv: 'Hur tillgänglig är er data för analys?',
            en: 'How accessible is your data for analysis?',
        },
        options: [
            { value: 'siloed', label: { sv: 'Data i separata system utan integration', en: 'Data in separate systems without integration' } },
            { value: 'partial', label: { sv: 'Delvis integrerad', en: 'Partially integrated' } },
            { value: 'mostly', label: { sv: 'Mestadels centraliserad', en: 'Mostly centralized' } },
            { value: 'full', label: { sv: 'Helt centraliserad och tillgänglig', en: 'Fully centralized and accessible' } },
        ],
        scoringDimension: 'data',
        scoringWeight: 10,
    },
    // Organization Dimension
    {
        id: 'ai_org_skills',
        section: 2,
        order: 6,
        type: 'single_select',
        required: true,
        text: {
            sv: 'Har ni interna resurser med AI/ML-kompetens?',
            en: 'Do you have internal resources with AI/ML expertise?',
        },
        options: [
            { value: 'none', label: { sv: 'Nej, ingen', en: 'No, none' } },
            { value: 'basic', label: { sv: 'Grundläggande intresse finns', en: 'Basic interest exists' } },
            { value: 'some', label: { sv: 'Någon med viss kompetens', en: 'Someone with some expertise' } },
            { value: 'dedicated', label: { sv: 'Dedikerade AI-resurser', en: 'Dedicated AI resources' } },
            { value: 'team', label: { sv: 'AI/Data science-team', en: 'AI/Data science team' } },
        ],
        scoringDimension: 'organization',
        scoringWeight: 10,
    },
    {
        id: 'ai_org_culture',
        section: 2,
        order: 7,
        type: 'scale',
        required: true,
        text: {
            sv: 'Hur öppen är er organisation för att testa ny teknik?',
            en: 'How open is your organization to testing new technology?',
        },
        description: {
            sv: '1 = Mycket konservativa, 5 = Mycket innovativa',
            en: '1 = Very conservative, 5 = Very innovative',
        },
        validation: {
            min: 1,
            max: 5,
        },
        scoringDimension: 'organization',
        scoringWeight: 5,
    },
    // Ethics Dimension
    {
        id: 'ai_ethics_awareness',
        section: 2,
        order: 8,
        type: 'single_select',
        required: true,
        text: {
            sv: 'Hur hanterar ni frågor kring AI-etik och ansvarsfull användning?',
            en: 'How do you handle questions about AI ethics and responsible use?',
        },
        options: [
            { value: 'not_considered', label: { sv: 'Har inte övervägt det', en: 'Have not considered it' } },
            { value: 'aware', label: { sv: 'Medvetna men ingen policy', en: 'Aware but no policy' } },
            { value: 'informal', label: { sv: 'Informella riktlinjer', en: 'Informal guidelines' } },
            { value: 'formal', label: { sv: 'Formella policyer', en: 'Formal policies' } },
            { value: 'comprehensive', label: { sv: 'Omfattande ramverk', en: 'Comprehensive framework' } },
        ],
        scoringDimension: 'ethics',
        scoringWeight: 5,
    },
    // Barriers and Opportunities
    {
        id: 'ai_barriers',
        section: 2,
        order: 9,
        type: 'multi_select',
        required: true,
        text: {
            sv: 'Vilka är de största hindren för att använda AI i ert företag?',
            en: 'What are the biggest barriers to using AI in your company?',
        },
        options: [
            { value: 'knowledge', label: { sv: 'Brist på kunskap', en: 'Lack of knowledge' } },
            { value: 'budget', label: { sv: 'Budget / resurser', en: 'Budget / resources' } },
            { value: 'data', label: { sv: 'Datakvalitet / tillgänglighet', en: 'Data quality / availability' } },
            { value: 'skills', label: { sv: 'Saknar kompetens internt', en: 'Lack internal expertise' } },
            { value: 'priority', label: { sv: 'Inte prioriterat', en: 'Not prioritized' } },
            { value: 'security', label: { sv: 'Säkerhets- / integritetsfrågor', en: 'Security / privacy concerns' } },
            { value: 'unclear_roi', label: { sv: 'Oklart ROI', en: 'Unclear ROI' } },
            { value: 'none', label: { sv: 'Inga större hinder', en: 'No major barriers' } },
        ],
        validation: {
            minSelections: 1,
        },
        scoringDimension: 'barrier',
        scoringWeight: 10,
    },
    {
        id: 'ai_priority_areas',
        section: 2,
        order: 10,
        type: 'ranking',
        required: true,
        text: {
            sv: 'Rangordna dessa områden efter var AI skulle kunna skapa mest värde för er:',
            en: 'Rank these areas by where AI could create the most value for you:',
        },
        options: [
            { value: 'efficiency', label: { sv: 'Effektivisera processer', en: 'Streamline processes' } },
            { value: 'customer', label: { sv: 'Förbättra kundupplevelse', en: 'Improve customer experience' } },
            { value: 'decisions', label: { sv: 'Bättre beslutsunderlag', en: 'Better decision-making' } },
            { value: 'costs', label: { sv: 'Minska kostnader', en: 'Reduce costs' } },
            { value: 'innovation', label: { sv: 'Nya produkter/tjänster', en: 'New products/services' } },
        ],
        allowAIRephrase: true,
    },
    // Budget and Timeline
    {
        id: 'ai_budget',
        section: 2,
        order: 11,
        type: 'single_select',
        required: true,
        text: {
            sv: 'Vilken budget har ni eller skulle ni överväga för AI-initiativ?',
            en: 'What budget do you have or would you consider for AI initiatives?',
        },
        options: [
            { value: 'none', label: { sv: 'Ingen budget avsatt', en: 'No budget allocated' } },
            { value: 'under_100k', label: { sv: 'Under 100 000 SEK', en: 'Under 100,000 SEK' } },
            { value: '100k-500k', label: { sv: '100 000 - 500 000 SEK', en: '100,000 - 500,000 SEK' } },
            { value: '500k-1m', label: { sv: '500 000 - 1 MSEK', en: '500,000 - 1 MSEK' } },
            { value: 'over_1m', label: { sv: 'Över 1 MSEK', en: 'Over 1 MSEK' } },
            { value: 'unknown', label: { sv: 'Vet ej', en: "Don't know" } },
        ],
        scoringDimension: 'budget',
        scoringWeight: 15,
    },
    {
        id: 'ai_timeline',
        section: 2,
        order: 12,
        type: 'single_select',
        required: true,
        text: {
            sv: 'När skulle ni kunna tänka er att påbörja ett AI-projekt?',
            en: 'When would you consider starting an AI project?',
        },
        options: [
            { value: 'now', label: { sv: 'Omedelbart', en: 'Immediately' } },
            { value: '3_months', label: { sv: 'Inom 3 månader', en: 'Within 3 months' } },
            { value: '6_months', label: { sv: 'Inom 6 månader', en: 'Within 6 months' } },
            { value: '12_months', label: { sv: 'Inom 12 månader', en: 'Within 12 months' } },
            { value: 'not_planned', label: { sv: 'Inget planerat', en: 'Nothing planned' } },
        ],
        scoringDimension: 'decisionSpeed',
        scoringWeight: 15,
    },
];
// Section 4: Contact Information Questions
export const contactQuestions = [
    {
        id: 'contact_email',
        section: 4,
        order: 1,
        type: 'email',
        required: true,
        text: {
            sv: 'Din e-postadress',
            en: 'Your email address',
        },
        description: {
            sv: 'Vi skickar din personliga AI-mognadsrapport hit',
            en: 'We will send your personal AI maturity report here',
        },
        validation: {
            pattern: '^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$',
        },
    },
    {
        id: 'contact_first_name',
        section: 4,
        order: 2,
        type: 'text',
        required: true,
        text: {
            sv: 'Förnamn',
            en: 'First name',
        },
        validation: {
            minLength: 1,
            maxLength: 100,
        },
    },
    {
        id: 'contact_last_name',
        section: 4,
        order: 3,
        type: 'text',
        required: true,
        text: {
            sv: 'Efternamn',
            en: 'Last name',
        },
        validation: {
            minLength: 1,
            maxLength: 100,
        },
    },
    {
        id: 'contact_company',
        section: 4,
        order: 4,
        type: 'text',
        required: true,
        text: {
            sv: 'Företagsnamn',
            en: 'Company name',
        },
        validation: {
            minLength: 1,
            maxLength: 200,
        },
    },
    {
        id: 'contact_phone',
        section: 4,
        order: 5,
        type: 'phone',
        required: false,
        text: {
            sv: 'Telefonnummer (valfritt)',
            en: 'Phone number (optional)',
        },
        description: {
            sv: 'Om du vill att vi kontaktar dig',
            en: 'If you want us to contact you',
        },
    },
    {
        id: 'contact_callback',
        section: 4,
        order: 6,
        type: 'checkbox',
        required: false,
        text: {
            sv: 'Ja, jag vill bli kontaktad för att diskutera hur AI kan hjälpa vårt företag',
            en: 'Yes, I want to be contacted to discuss how AI can help our company',
        },
        scoringDimension: 'callbackInterest',
        scoringWeight: 10,
    },
    {
        id: 'contact_newsletter',
        section: 4,
        order: 7,
        type: 'checkbox',
        required: false,
        text: {
            sv: 'Ja, jag vill få nyhetsbrev med tips och insikter om AI',
            en: 'Yes, I want to receive newsletters with AI tips and insights',
        },
    },
    {
        id: 'contact_gdpr',
        section: 4,
        order: 8,
        type: 'checkbox',
        required: true,
        text: {
            sv: 'Jag godkänner att mina uppgifter lagras och behandlas enligt GDPR',
            en: 'I consent to my data being stored and processed according to GDPR',
        },
        description: {
            sv: 'Läs vår integritetspolicy',
            en: 'Read our privacy policy',
        },
    },
];
// All questions combined
export const allQuestions = [
    ...backgroundQuestions,
    ...aiMaturityQuestions,
    ...contactQuestions,
];
// Helper to get questions by section
export function getQuestionsBySection(section) {
    return allQuestions.filter((q) => q.section === section);
}
// Helper to get a question by ID
export function getQuestionById(id) {
    return allQuestions.find((q) => q.id === id);
}
// Section configuration
export const sections = [
    {
        id: 1,
        title: { sv: 'Om ditt företag', en: 'About your company' },
        description: { sv: 'Några frågor om dig och ditt företag', en: 'A few questions about you and your company' },
    },
    {
        id: 2,
        title: { sv: 'AI-mognad', en: 'AI Maturity' },
        description: { sv: 'Bedöm er nuvarande AI-mognad', en: 'Assess your current AI maturity' },
    },
    {
        id: 3,
        title: { sv: 'Fördjupade frågor', en: 'Deep-dive questions' },
        description: { sv: 'Personaliserade frågor baserat på era svar', en: 'Personalized questions based on your answers' },
    },
    {
        id: 4,
        title: { sv: 'Kontaktuppgifter', en: 'Contact information' },
        description: { sv: 'Var ska vi skicka din rapport?', en: 'Where should we send your report?' },
    },
];
//# sourceMappingURL=questions.js.map